<template>
    <b-card no-body>
        <v-table    ref="table"
                    :items-provider="provider"
                    :fields="fields"
                    pagination="server"
                    :settings="false"
                    v-on:fetch-result-raw="onFetch">
                    <template #additional-actions>
                        <div class="row">
                            <div class="col-md-1 mb-1 mb-md-0">
                                <select class="form-control bg-img-none" v-model="donem.month">
                                    <option v-for="m in months" :key="m.index" :value="m.index">{{m.name}}</option>
                                </select>
                            </div>
                            <div class="col-md-1 mb-1 mb-md-0">
                                <select class="form-control bg-img-none" v-model="donem.year">
                                    <option v-for="y in years" :key="y" :value="y">{{y}}</option>
                                </select>
                            </div>
                            <div class="col-md-auto mb-1 mb-md-0">
                                <select class="form-control bg-img-none" v-model="branchType">
                                    <option value="O">Org. Şube</option>
                                    <!-- <option value="S">SGK Şube</option> -->
                                </select>
                            </div>
                            <div class="col-md-3 mb-1 mb-md-0" v-if="branchType == 'O'">
                                <v-select-list :options="branches" label="Name" v-model="branch" placeholder="Tüm Org. Şubeler"></v-select-list>
                            </div>
                            <!-- <div class="col-md-3 mb-1 mb-md-0" v-if="branchType == 'S'">
                                <v-select-list :options="sbranches" label="Name" v-model="sbranch" placeholder="Tüm SGK Şubeler"></v-select-list>
                            </div> -->
                            <div class="col-md-2 mb-1 mb-md-0">
                                <v-select-list :options="collarStatuses" label="Name" v-model="collarStatus" placeholder="Tüm Yakalar"></v-select-list>
                            </div>
                            <div class="col-md-2 mb-1 mb-md-0">
                                <input class="form-control" placeholder="Personel" v-model="search"/>
                            </div>
                            <div class="col-auto">
                                <button class="btn btn-success" v-on:click="$refs.table.refresh()">Sorgula</button>
                            </div>
                            <div class="col-auto" v-if="excelPath">
                                <button class="btn btn-outline-success" v-on:click="downloadExcel">Excel</button>
                            </div>
                        </div>
                    </template>
                </v-table>
    </b-card>
</template>

<script>
import EmployeeOperationsApi from '@/api/employee-operations';
import { BCard } from 'bootstrap-vue';
import moment from 'moment'
import SystemDataApi from '@/api/system-data'
import CompanyApi from '@/api/company'
import Additional from '@/utilities/additional';

export default {
    components:{
        BCard
    },
    data(){
        return {
            fields:[
                {key:'FullName',name:'Personel',tdClass:'text-nowrap',sticky:true},
                {key:'IdentityNumber',name:'Kimlik Numarası'},
                {key:'CollarStatusName',name:'Yaka',tdClass:'text-nowrap'},
                {key:'OperationalBranchName',name:'Org. Şube',tdClass:'text-nowrap'},
                {key:'GarageName',name:'Görev Yeri',tdClass:'text-nowrap'},
                {key:'SGKEntryDateStr',name:'Giriş Tarihi'},
                {key:'SGKExitDateStr',name:'Çıkış Tarihi'},
                {key:'OperationalSalaryStr',name:'Sabit Maaş',tdClass:'text-right'},
                {name:'Toplam Vergi ve Harçlar',children:[
                    {key:'SSK_PRIMIStr',name:'SGK Primi',tdClass:'text-right'},
                    {key:'SSK_PRIM_ISVERENStr',name:'SGK Prim İşveren Payı',tdClass:'text-right'},
                    {key:'SSK_TESVIKIStr',name:'SGK Teşvik',tdClass:'text-right'},
                    {key:'ISSIZLIK_PRIMIStr',name:'İşsizlik Primi İşçi Payı',tdClass:'text-right'},
                    {key:'ISSIZLIK_PRIM_ISVERENStr',name:'İşsizlik Primi İşveren Payı',tdClass:'text-right'},
                    {key:'GELIR_VERGISIStr',name:'Gelir Vergisi',tdClass:'text-right'},
                    {key:'DAMGA_VERGISIStr',name:'Damga Vergisi',tdClass:'text-right'},
                ]},
                {key:'TotalPriceStr',name:'Toplam Ücretler [VH]',tdClass:'text-right'},
                {key:'TotalTaxesStr',name:'Toplam Vergi ve Harçlar',tdClass:'text-right'},
                {key:'TotalAllStr',name:'Toplam Maliyet',tdClass:'text-right'},
                {key:'MessagesComma',name:'Hatalar',tdClass:'text-right text-nowrap text-secondary',thClass:'bg-light-secondary'}
            ],
            years:[],
            months:[
                {index:1,name:'Ocak'},
                {index:2,name:'Şubat'},
                {index:3,name:'Mart'},
                {index:4,name:'Nisan'},
                {index:5,name:'Mayıs'},
                {index:6,name:'Haziran'},
                {index:7,name:'Temmuz'},
                {index:8,name:'Ağustos'},
                {index:9,name:'Eylül'},
                {index:10,name:'Ekim'},
                {index:11,name:'Kasım'},
                {index:12,name:'Aralık'}
            ],
            donem:{
                year:moment().year(),
                month:moment().month() + 1 
            },
            branches:[],
            sbranches:[],
            collarStatuses:[],
            branchType:'O',
            branch:null,
            sbranch:null,
            collarStatus:null,
            excelPath:null,
            search:''
        }
    },
    mounted(){
        this.configureYears()
        this.getBranches()
        this.getSBranches()
        this.getCollarStatuses()
    },
    methods:{
        provider(data){
            return EmployeeOperationsApi.Report.EmployeeExpense({
                PaginateRequest:{
                    ...data,
                    QueryParam:this.search
                },
                ...this.filter
            })
        },
        onFetch(e){
            this.excelPath = e.data.ExcelPath
        },
        getBranches(){
            CompanyApi.Branch.ListByCode("O").then(res=>{
                this.branches = res.data.Data
            })
        },
        getSBranches(){
            CompanyApi.Branch.ListByCode("S").then(res=>{
                this.sbranches = res.data.Data
            })
        },
        getCollarStatuses(){
            SystemDataApi.CollarStatus().then(res => {
                this.collarStatuses = res.data.Data
            })
        },
        configureYears(){  
            let years = []
            let year = moment().add(1,'year').format('YYYY')
            let firstYear = 1900
            while (firstYear <= year){
                years.push(firstYear++)
            }
            this.years = years.reverse()
        },
        downloadExcel(){
            if(this.excelPath){
                Additional.DownloadTab(this.excelPath)
            }
        }
    },
    computed:{
        filter(){
            return {
                BranchId: this.branchType == 'O' ? (this.branch?.Id || null) : (this.sbranch?.Id || null),
                BranchTypeCode: this.branchType,
                CollarStatusId: this.collarStatus?.Id || null,
                Month: this.donem.month,
                Year: this.donem.year,
            }
        }
    }
}
</script>